<template>
  <div id="app">
<!--    <top/>-->
    <router-view/>
    <copy-right/>

    <login-modal/>
  </div>
</template>

<script>


import Top from "@/components/Top.vue";
import CopyRight from "@/components/CopyRight.vue";
import LoginModal from "@/views/LoginModal.vue";

export default {
  name: 'App',
  components: {LoginModal, CopyRight, Top},

}
</script>

<style>
#app {
  font-family: PingFangSC-Regular, PingFang SC, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding: 0;
  margin: 0;
}

.head-top-bottom {
  border-bottom: solid 1px #B8D8E9;
}


</style>
